import React from 'react';
import { Button, Drawer, Modal, Space } from 'antd';
import { useWorkbenchContext } from '../../contexts/WorkbenchContext';

export function WorkbenchDrawer({ children, title, footer, ...props }) {
  const embedded = useWorkbenchContext();
  if (!embedded) return <Drawer title={title} footer={footer} {...props}>{children}</Drawer>;
  return props.open ? <section className="sw-inline-form" aria-label={title}>
    <h3>{title}</h3>{children}<div className="sw-form-footer">{footer}</div>
  </section> : null;
}
export function WorkbenchModal({ children, title, ...props }) {
  const embedded = useWorkbenchContext();
  if (!embedded) return <Modal title={title} {...props}>{children}</Modal>;
  return props.open ? <section className="sw-inline-form" aria-label={title}>
    <h3>{title}</h3>{children}<Space>
      <Button onClick={props.onCancel}>取消</Button>
      <Button type="primary" onClick={props.onOk} loading={props.confirmLoading}>{props.okText || '提交'}</Button>
    </Space>
  </section> : null;
}
